<app-admin-list-page [title]="'Events' | translate">

  <a slot="actions" class="btn btn-primary" routerLink="/admin/externalpage/Event">
    {{'Add new' | translate}}
  </a>

  <app-table [config]="configTable" (buttonEvent)="handleButtonEvent($event)"></app-table>

</app-admin-list-page>
